// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 20 16", width: "20", height: "16" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", null,
                React.createElement("path", { d: "M396.165988,677.032341 C393.994256,676.804334 392.614215,677.800363 391,679.43801 C389.295782,677.800363 388.005744,676.804334 385.834012,677.032341 C382.88059,677.34195 380.566354,680.576443 381.068869,683.399724 C381.874726,687.927054 386.022351,690.599931 391,693 C395.977649,690.599931 400.126107,687.927054 400.931131,683.399724 C401.433646,680.576443 399.11941,677.34275 396.165988,677.032341 Z", transform: "translate(-381 -677)" })))));
};
Icon.displayName = 'Heart20x16';
export default Icon;
//# sourceMappingURL=Heart20x16.js.map